var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright"},[_c('a',{attrs:{"target":"_blank","href":"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010302000485"}},[_c('img',{attrs:{"src":"images/beian.png"}}),_c('span',[_vm._v("粤公网安备 44010302000485号")])]),_c('br'),_c('a',{attrs:{"href":"http://beian.miit.gov.cn","target":"blank"}},[_vm._v("粤ICP备18059277号-1")])])
}]

export { render, staticRenderFns }